class HeaderScrollController {
    constructor() {
        this.header = document.querySelector('#SiteHeader');
        if (!this.header) return;
        
        this.lastScrollTop = 0;
        this.scrollThreshold = 10;
        this.init();
    }
    
    init() {
        this.addHeaderStyles();
        window.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 16));
        this.header.classList.add('header-scroll-visible');
    }
    
    addHeaderStyles() {
        const style = document.createElement('style');
        style.textContent = `
            .site-header {
                transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                will-change: transform;
            }
            .site-header.header-scroll-hidden {
                transform: translateY(-100%) !important;
            }
            .site-header.header-scroll-visible {
                transform: translateY(0) !important;
            }
            .site-header--relative {
                position: fixed !important;
                top: 0;
                left: 0;
                right: 0;
                z-index: 1000;
            }
            body.header-fixed {
                padding-top: var(--header-height, 80px);
            }
        `;
        document.head.appendChild(style);
        
        const headerHeight = this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        document.body.classList.add('header-fixed');
    }
    
    handleScroll() {
        const currentScrollTop = window.pageYOffset;
        if (currentScrollTop < 0) return;
        
        const scrollDifference = currentScrollTop - this.lastScrollTop;
        if (Math.abs(scrollDifference) < this.scrollThreshold) return;
        
        if (scrollDifference > 0 && currentScrollTop > 100) {
            this.hideHeader();
        } else if (scrollDifference < 0 || currentScrollTop <= 100) {
            this.showHeader();
        }
        
        this.lastScrollTop = currentScrollTop;
    }
    
    hideHeader() {
        this.header.classList.remove('header-scroll-visible');
        this.header.classList.add('header-scroll-hidden');
    }
    
    showHeader() {
        this.header.classList.remove('header-scroll-hidden');
        this.header.classList.add('header-scroll-visible');
    }
    
    throttle(func, limit) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    new HeaderScrollController();
});